import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { ScrollToPlugin } from "gsap/ScrollToPlugin"
import Swiper from 'swiper/bundle'
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

/**
 * TreatmentNav functionality.
 * @author Dayne Coulson-Hoffacker
 */

export default class TreatmentNav {
/**
   * Constructs a new TreatmentNav instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */

  constructor(options) {
    this.element = options.element
    this.swiperElement = this.element.querySelector('.swiper')
    this.links = this.element.querySelectorAll('.swiper-slide a')
    this.mediaQuery = window.matchMedia('(min-width: 1024px)')

    const treatmentNav = new Swiper(this.swiperElement, {
      slidesPerView: "auto",
      spaceBetween: 20,
      freeMode: true,
      mousewheel: true,
      mousewheelSensitivity: 0,
      mousewheelReleaseOnEdges: true,
    })

    this.links.forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault()
        if (this.mediaQuery.matches) {
          gsap.to(window, { duration: 1, scrollTo: { y: e.target.getAttribute("href"), offsetY: 149 }, ease: "power4" })
        } else {
          gsap.to(window, { duration: 1, scrollTo: { y: e.target.getAttribute("href"), offsetY: 194 }, ease: "power4" })
        }
      })
    })
  }
}
